<template>
  <div>
    <div class="toolbar">
      <el-radio-group v-model="status" size="small" @change="load">
        <el-radio-button label="PENDING">待认款</el-radio-button>
        <el-radio-button label="CONFIRMED">已开通</el-radio-button>
        <el-radio-button label="REJECTED">已驳回</el-radio-button>
        <el-radio-button label="ALL">全部</el-radio-button>
      </el-radio-group>
      <el-button type="primary" icon="el-icon-plus" @click="openManual">手动开通</el-button>
    </div>

    <el-table :data="list" border stripe v-loading="loading">
      <el-table-column prop="tenantName" label="企业" min-width="160" />
      <el-table-column prop="tenantCode" label="租户编码" width="140" />
      <el-table-column prop="planName" label="套餐" width="120" />
      <el-table-column label="金额" width="120">
        <template slot-scope="{ row }">{{ formatPrice(row.amountCent) }}</template>
      </el-table-column>
      <el-table-column prop="payerName" label="汇款户名" min-width="140" show-overflow-tooltip />
      <el-table-column prop="transferNo" label="流水号" min-width="140" show-overflow-tooltip />
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="{ row }">{{ statusText(row.status) }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="提交时间" width="170" />
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="{ row }">
          <template v-if="row.status === 'PENDING'">
            <el-button type="text" @click="confirm(row)">认款开通</el-button>
            <el-button type="text" style="color:#f56c6c" @click="reject(row)">驳回</el-button>
          </template>
          <span v-else class="muted">-</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="手动开通套餐" :visible.sync="manualVisible" width="460px" append-to-body>
      <el-form :model="manual" label-width="100px">
        <el-form-item label="租户编码" required>
          <el-input v-model="manual.tenantCode" placeholder="如 t13800001111" />
        </el-form-item>
        <el-form-item label="套餐" required>
          <el-select v-model="manual.planCode" placeholder="请选择" style="width:100%">
            <el-option v-for="p in paidPlans" :key="p.planCode" :label="p.planName" :value="p.planCode" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="manualVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitManual">开通</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSubscription, listPayNotices, confirmPayNotice, rejectPayNotice, activatePlan } from '../../api/sys'

export default {
  name: 'SysPayNotice',
  data() {
    return {
      loading: false,
      saving: false,
      status: 'PENDING',
      list: [],
      paidPlans: [],
      manualVisible: false,
      manual: { tenantCode: '', planCode: 'PRO' }
    }
  },
  created() {
    this.load()
    this.loadPlans()
  },
  methods: {
    statusText(status) {
      const map = { PENDING: '待认款', CONFIRMED: '已开通', REJECTED: '已驳回' }
      return map[status] || status || '-'
    },
    formatPrice(cent) {
      if (cent == null) return '-'
      return (Number(cent) / 100).toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' 元'
    },
    async loadPlans() {
      try {
        const res = await getSubscription()
        this.paidPlans = ((res.data && res.data.plans) || []).filter(p =>
          !['TRIAL', 'FREE', 'PRIVATE', 'ENT'].includes(p.planCode) && p.priceCent > 0
        )
      } catch (e) { /* ignore */ }
    },
    async load() {
      this.loading = true
      try {
        const res = await listPayNotices({ status: this.status })
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    confirm(row) {
      this.$confirm(`确认「${row.tenantName}」已到账 ${this.formatPrice(row.amountCent)}，开通「${row.planName}」？`, '认款开通', { type: 'warning' })
        .then(async () => {
          await confirmPayNotice(row.id)
          this.$message.success('已开通')
          this.load()
        })
        .catch(() => {})
    },
    reject(row) {
      this.$prompt('请输入驳回原因（选填）', '驳回认款', {
        inputPlaceholder: '如：未查到该笔转账',
        confirmButtonText: '驳回',
        cancelButtonText: '取消'
      }).then(async ({ value }) => {
        await rejectPayNotice(row.id, { remark: value })
        this.$message.success('已驳回')
        this.load()
      }).catch(() => {})
    },
    openManual() {
      this.manual = { tenantCode: '', planCode: 'PRO' }
      this.manualVisible = true
    },
    async submitManual() {
      if (!this.manual.tenantCode || !this.manual.planCode) {
        return this.$message.warning('请填写租户编码和套餐')
      }
      this.saving = true
      try {
        await activatePlan(this.manual.planCode, this.manual.tenantCode)
        this.manualVisible = false
        this.$message.success('已开通')
        this.load()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.muted { color: #94a3b8; }
</style>
